import axios from "axios";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams.js";
import { paramsToString } from "../../../../utils/parseToString.js";

export const FETCH_HEATMAP_DATA = "saga/retentionHeatmap/FETCH_HEATMAP_DATA";
export const FETCH_HEATMAP_DATA_SUCCESS = "saga/retentionHeatmap/FETCH_HEATMAP_DATA_SUCCESS";
export const FETCH_HEATMAP_DATA_FAILURE = "saga/retentionHeatmap/FETCH_HEATMAP_DATA_FAILURE";
export const FETCH_FILTERS_SUCCESS = "saga/retentionHeatmap/FETCH_FILTERS_SUCCESS";
export const UPDATE_SECONDARY_CATEGORY = "saga/retentionHeatmap/UPDATE_SECONDARY_CATEGORY";
export const UPDATE_HEATMAP_DATA = "saga/retentionHeatmap/UPDATE_HEATMAP_DATA";
export const SET_LOADING = "saga/retentionHeatmap/SET_LOADING";
export const SET_FILTERS_DIRTY = "saga/retentionHeatmap/SET_FILTERS_DIRTY";
export const RESET_FILTERS = "saga/retentionHeatmap/RESET_FILTER";
export const SET_MEMBERSHIP_LOGIC = "saga/retentionHeatmap/SET_MEMBERSHIP_LOGIC";

export const actionCreators = {
  fetchHeatmapData: createAction(FETCH_HEATMAP_DATA),
  updateSecondaryCategory: createAction(UPDATE_SECONDARY_CATEGORY),
  updateHeatmapData: createAction(UPDATE_HEATMAP_DATA),
  resetFilters: createAction(RESET_FILTERS)
};

export default function* watchStars() {
  yield takeLatest(FETCH_HEATMAP_DATA, getHeatmapData);
  yield takeLatest(UPDATE_HEATMAP_DATA, updateHeatmapData);
  yield takeLatest(RESET_FILTERS, resetFilters);
}

function* getCommonApiParams() {
  return yield select((state) => {
    return {
      organization_id: state.commonReducer.commonProps.organization_id.toString(),
      short_url: state.commonReducer.commonProps.short_url
    };
  });
}

export function* getHeatmapData({ payload }) {
  try {
    yield put({ type: SET_LOADING, payload: true });

    const { membershipLogic: storedMembershipLogic } = yield select(
      (state) => state.retentionHeatmap
    );
    const membershipLogic = payload.membershipLogic ?? storedMembershipLogic;
    yield put({ type: SET_MEMBERSHIP_LOGIC, payload: membershipLogic });

    const isNumberOfMembersByProfile = membershipLogic === "NumberOfMembersByProfile";

    if (!payload.update && !isNumberOfMembersByProfile) {
      yield fetchFilters(payload);
    }

    const { selectedSecondaryCategories } = yield select((state) => state.retentionHeatmap);
    const values =
      !isNumberOfMembersByProfile && selectedSecondaryCategories.length
        ? selectedSecondaryCategories.map((p) => p.id).join(",")
        : "";

    const res = yield call(
      axios.get,
      queryParams.apiVersion +
        "pages/memberships/membership_retention_heatmap" +
        "?organization_id=" +
        payload.organization_id +
        "&short_url=" +
        payload.short_url +
        (values ? `&secondary_categories=${values} ` : "") +
        (payload?.categories && payload.categories.length
          ? "&categories=" + paramsToString(payload.categories)
          : "") +
        (payload?.classPass ? "&class_pass=" + payload.classPass : "") +
        (payload?.numbersOrPercentages
          ? "&numbers_or_percentages=" + payload.numbersOrPercentages
          : "")
    );

    // TODO: this is correction from snake case to camel case, remove on backend fix
    const filters = res.data.filters;
    if (filters && filters.class_pass) {
      res.data.filters = {
        tooltip: filters.tooltip,
        classPass: filters.class_pass,
        numbersOrPercentages: filters.numbers_or_percentages,
        classPasses: filters.class_passess
      };
    }

    yield put({ type: FETCH_HEATMAP_DATA_SUCCESS, payload: res.data });
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_HEATMAP_DATA_FAILURE, error });
  }
}

export function* updateHeatmapData() {
  const sagaArguments = yield getCommonApiParams();
  const { filters } = yield select((state) => state.retentionHeatmap);
  const payload = { ...filters, ...sagaArguments };

  yield getHeatmapData({ payload: { ...payload, update: true } });
}

function* resetFilters() {
  yield put({ type: SET_LOADING, payload: true });
  try {
    yield updateHeatmapData();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* fetchFilters(params) {
  const { organization_id, short_url } = params;

  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "pages/memberships/membership_retention_heatmap/get_filters" +
        "?organization_id=" +
        organization_id +
        "&short_url=" +
        short_url
    );

    yield put({ type: FETCH_FILTERS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
  }
}
